import React, { FC, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from 'shared-components/atom/select';
//import { staticValue } from '../../constants';
import { useAutomationGlobalMethods } from '../../hooks';
import { AutomationSettingsFactoryTypesProps } from '../../types';
import TextArea from 'shared-components/atom/texatarea';
import Radio from 'shared-components/atom/radio';
import './styles.scss';

const HumanAutomation: FC<AutomationSettingsFactoryTypesProps> = ({
  automationSendSettings,
  automationIndex,
  selectedRecipes,
  setAutomationSendSettings,
  setCompletedFields,
  id,
  isSettingsChange,
  setIsDirty,
}) => {
  const [fieldList, setFieldList] = useState<any>([]);
  const [clicked, setClicked] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedSource, setSelectedSource] = useState<any>([]);
  const [type, setType] = useState('text');

  const {
    liftingSettings,
    getDynamicAndIntegrationsSettings,
    getPreviousAutomationOutputOrPreviousRecipKeys,
    restoreSelectedSource,
  } = useAutomationGlobalMethods({
    automationSendSettings,
    setAutomationSendSettings,
    selectedRecipes,
    automationIndex,
    id,
  });

  const checkFields = () => {
    if (fieldList?.length === 0 || !searchKeyword) return false;
    return true;
  };

  useEffect(() => {
    const { dynamic_settings } = getDynamicAndIntegrationsSettings();
    if (dynamic_settings) {
      const { keys } = dynamic_settings;
      const { settings } = keys[0];
      const keywords = settings ? settings.keywords : keys[0].keywords;
      const type = settings ? settings.type : keys[0].type;
      setSearchKeyword(keywords.join(', '));
      setType(type);
    }
  }, [isSettingsChange]);

  //recipe
  useEffect(() => {
    // if (fieldList.length > 0) return;
    if (automationIndex === 0) return;
    let options = getPreviousAutomationOutputOrPreviousRecipKeys();
    const { dynamic_settings } = getDynamicAndIntegrationsSettings();
    if (dynamic_settings) {
      const key = dynamic_settings.keys[0].key;
      restoreSelectedSource({ key: key, fieldList: options, setSelectedSource: setSelectedSource });
    }
    setFieldList(options);
  }, []);

  useEffect(() => {
    liftingSettings({
      outputKeysData: [
        ...fieldList.map((item: { value: any }) => item.value),
        '_human_powered_question',
        '_human_powered_answer',
      ],
    });
  }, [fieldList]);

  useEffect(() => {
    if (!clicked) return;
    setCompletedFields({ index: automationIndex, checked: checkFields() });
    // setClicked(false);
    let localSettings = {
      keys: [
        {
          inputValue: null,
          key: fieldList.length && selectedSource ? selectedSource.value : null,
          settings: {
            keywords: searchKeyword.split(',').map(item => item.trim()),
            type: type,
          },
        },
      ],
    };
    liftingSettings({
      dynamicSettings: localSettings,
    });
  }, [searchKeyword, selectedSource, type]);

  const handleRadioChange = (val: string) => {
    setType(val);
    !clicked && setClicked(true);
    setIsDirty();
  };

  return (
    <div>
      <Row>
        <Col lg={6} className="mb-4">
          <span className="label secondary-color">Select source</span>
          <Select
            options={fieldList}
            value={selectedSource}
            placeholder={'Select source'}
            onChange={(selectedItem: any) => {
              setSelectedSource(selectedItem);
              !clicked && setClicked(true);
              setIsDirty();
            }}
          />
        </Col>
        <Col lg={6} className="mb-4">
          <span className="label secondary-color">Choose answer type</span>
          <div className="d-flex align-items-center h-75">
            <Radio
              className="white"
              label="Text"
              value="text"
              checked={type === 'text'}
              onClick={() => handleRadioChange('text')}
            />
            <Radio
              className="white"
              label="Number"
              value="number"
              checked={type === 'number'}
              onClick={() => handleRadioChange('number')}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <span className="label secondary-color">Question</span>
          <TextArea
            value={searchKeyword}
            onChange={(e: any) => {
              setSearchKeyword(e.target.value);
              !clicked && setClicked(true);
              setIsDirty();
            }}
            placeholder="What do you want to ask?"
          />
        </Col>
      </Row>
    </div>
  );
};
export default React.memo(HumanAutomation);
